export default __webpack_public_path__ + "static/media/logo.8859b11a.jpg";